import { selectInstructor, selectYogaType } from 'store/personalPlan/selectors';

import { YogaInstructor, YogaType } from 'constants/personalPlan';

import { useSelector } from 'hooks';

import wall_pilates from './img/wall_pilates.webp';
import somatic from './img/somatic.webp';
import classic from './img/classic.webp';
import chair_yoga_John from './img/chair_yoga_John.webp';
import chair_yoga_Anke from './img/chair_yoga_Anke.webp';

import { MoveCurrentSlideToEndType, UseGetSliderConfigType } from './types';

export const moveCurrentSlideToEnd: MoveCurrentSlideToEndType = (slides) => {
    const index = slides.findIndex((obj) => obj.isCurrentPlan);

    if (index !== -1 && index !== slides.length - 1) {
        const current = slides[index];

        return [...slides.slice(0, index), ...slides.slice(index + 1), current];
    }

    return slides;
};

export const useGetSliderConfig: UseGetSliderConfigType = () => {
    const yogaType = useSelector(selectYogaType);
    const yogaInstructor = useSelector(selectInstructor);

    const slides = [
        {
            img: wall_pilates,
            isCurrentPlan: yogaType === YogaType.WallPilates,
            title: 'subscription.additionalContentOfferModal.modalA.slider.wall_pilates.title',
            description: 'subscription.additionalContentOfferModal.modalA.slider.wall_pilates.description',
        },
        {
            img: chair_yoga_John,
            isCurrentPlan: yogaType === YogaType.ChairYoga && yogaInstructor === YogaInstructor.John,
            title: 'subscription.additionalContentOfferModal.modalA.slider.chair_yoga_John.title',
            description: 'subscription.additionalContentOfferModal.modalA.slider.chair_yoga_John.description',
        },
        {
            img: chair_yoga_Anke,
            isCurrentPlan: yogaType === YogaType.ChairYoga && yogaInstructor === YogaInstructor.Anke,
            title: 'subscription.additionalContentOfferModal.modalA.slider.chair_yoga_Anke.title',
            description: 'subscription.additionalContentOfferModal.modalA.slider.chair_yoga_Anke.description',
        },
        {
            img: classic,
            isCurrentPlan: yogaType === YogaType.Classic,
            title: 'subscription.additionalContentOfferModal.modalA.slider.classic.title',
            description: 'subscription.additionalContentOfferModal.modalA.slider.classic.description',
        },
        {
            img: somatic,
            isCurrentPlan: yogaType === YogaType.SomaticYoga,
            title: 'subscription.additionalContentOfferModal.modalA.slider.somatic.title',
            description: 'subscription.additionalContentOfferModal.modalA.slider.somatic.description',
        },
    ];

    return moveCurrentSlideToEnd(slides);
};
